import React, { useEffect, useState } from 'react';
import Form, { useForm } from '../../molecules/Form';
import Button from '../../molecules/Button';
import Toast from '../../molecules/Toast';
import DragableComponent from '../DraggableComponent/DragableComponent';
import { GoArrowLeft } from 'react-icons/go';
import campaignService from '../../../services/campaignService';
import Loaders from '../Loaders';

const LeadsColumnMaping = ({ setData, data, NextStep, setStep, step, totalStep = 5 }) => {
  const [form] = useForm();
  const [dragItems, setDragItems] = useState({ root: [], container1: [] });
  const [loading, setLoading] = useState(false);
  const [leadsColumns, setLeadsColumns] = useState();
  const predefinedFields = [
    { key: 'first_name', label: 'First Name', editable: false, required: false },
    { key: 'last_name', label: 'Last Name', editable: false, required: false },
    { key: 'email', label: 'Email', editable: false, required: true },
    { key: 'website', label: 'Website', editable: false, required: false },
    { key: 'location', label: 'Company Country', editable: false, required: false },
    { key: 'title', label: 'Title', editable: false, required: false },
    { key: 'company_name', label: 'Company Name for Emails', editable: false, required: false },
    { key: 'industry', label: 'Industry', editable: false, required: false },
    { key: 'technologies', label: 'Tech Stack', editable: false, required: false },
  ];

  const [dragableData, setDragableData] = useState(predefinedFields);

  const handleAddField = () => {
    setDragableData(prev => {
      const updated = [...prev, { key: 'newKey', label: 'New Field', editable: true, required: false }];

      setDragItems(prevItems => ({
        ...prevItems,
        root: [...prevItems.root, null],
      }));

      return updated;
    });
  };

  const handleEditLabel = (index, newLabel) => {
    setDragableData(prev => {
      const updated = [...prev];
      updated[index].label = newLabel;
      updated[index].key = newLabel.toLowerCase().replace(/\s+/g, '_');
      return updated;
    });
  };

  const link =
    'https://outreach-outputmsg-staging.s3.eu-central-1.amazonaws.com/output_csvs/1752652730276_local_testing_record_processed.csv'; // make it dynamic

  async function handleGetEnrichLeadsColumn() {
    try {
      const res = await campaignService.getEnrichLeadsColumn({ out_csv: data?.step1?.out_csv });
      // const res = await campaignService.getEnrichLeadsColumn({ out_csv: link });
      setLeadsColumns(res?.data);
    } catch (error) {
      Toast({
        type: 'error',
        message: error.message,
      });
    }
  }

  useEffect(() => {
    handleGetEnrichLeadsColumn();
  }, []);

  const handelSubmit = async e => {
    try {
      setLoading(true);

      const columnNames = {};
      const customFields = {};

      dragableData.forEach((item, index) => {
        const mappedColumn = dragItems.root?.[index]?.rowKey;

        if (item.editable) {
          customFields[item.key] = mappedColumn;
        } else {
          columnNames[item.key] = mappedColumn;
        }
      });

      columnNames.custom_fields = customFields;

      Object.assign(columnNames, {
        message_one: 'message_one',
        subject_one: 'subject_one',
        message_two: 'message_two',
        subject_two: 'subject_two',
        message_three: 'message_three',
        subject_three: 'subject_three',
      });

      const payload = {
        campaignName: data?.step1?.campaign_name,
        out_csv: data?.step1?.out_csv,
        // out_csv: link,
        columnNames,
        isEnrichment: true,
        leads_type: 'houdiny_leads',
        task_id: data?.step1?.task_id,
        tagId: data?.step1?.tag, // Include selected tag ID from Step1
      };

      const { first_name, last_name, email } = columnNames;

      if (!first_name || !last_name || !email) {
        Toast({
          type: 'error',
          message: 'First name, last name and email are required',
        });
        return;
      }

      const res = await campaignService.addHoudinyLeadsToCampaign(payload);

      if (res?.success) {
        Toast({ type: 'success', message: 'Leads Added Successfully' });
        setStep(6);
        setData(prev => ({
          ...prev,
          leadsSequenceData: res?.data?.leadData,
          houndintLeadsColumns: columnNames,
          isEnrichment: true,
          isHoudinyLeads: true,
          campaignId: res?.data?.campaignId,
          leads_type: 'houdiny_leads',
        }));
      }
    } catch (err) {
      Toast({ type: 'error', message: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {leadsColumns?.length > 0 ? (
        <>
          <div className="head">
            <button onClick={() => setStep(1)}>
              <GoArrowLeft size={25} />
            </button>
            <div>
              <span className="heading">Leads Column Maping</span>
              <p>
                Step {step} of {totalStep}: Column Mapping for Analysis
              </p>
            </div>
          </div>
          <Form form={form}>
            <DragableComponent
              initialItems={{
                root: Array(dragableData.length).fill(null),
                container1: leadsColumns?.map((name, index) => ({
                  id: `lead-col-${index}`,
                  title: name,
                  rowKey: name,
                  originalIndex: index,
                })),
              }}
              onItemsChange={setDragItems}
              dragableData={dragableData}
              onEditLabel={handleEditLabel}
              onAddField={handleAddField}
            />

            <div className="btn-holder">
              <Button onClick={() => handelSubmit()} loader={loading} disabled={loading}>
                Next
              </Button>
            </div>
          </Form>
        </>
      ) : (
        <div className="no-leads-loader">
          <Loaders viewLoader />
        </div>
      )}
    </>
  );
};

export default LeadsColumnMaping;
